import { Avatar, Button, IndexTable, TextStyle } from "@shopify/polaris";
import { EditMinor } from "@shopify/polaris-icons";
import { Link } from "components";

export function UserRows({ data = [] }) {
  return data.map(({ _id, name, email, tel, status }, index) => (
    <IndexTable.Row id={_id} key={_id} position={index} subdued>
      <IndexTable.Cell>
        <div className="py-5 flex items-center">
          <div>
            <Avatar customer name={name} />
          </div>
          <div className="pl-2 flex flex-col">
            <Link url={`/users/${_id}`}>
              <TextStyle variation="strong">{name}</TextStyle>
            </Link>
            <TextStyle variation="subdued">{email}</TextStyle>
          </div>
        </div>
      </IndexTable.Cell>
      <IndexTable.Cell>{tel}</IndexTable.Cell>
      <IndexTable.Cell>{status}</IndexTable.Cell>
      <IndexTable.Cell>
        <Button
          url={`/users/${_id}`}
          plain
          monochrome
          icon={EditMinor}
        ></Button>
      </IndexTable.Cell>
    </IndexTable.Row>
  ));
}
